import { render, staticRenderFns } from "./DealValueAddEdit.vue?vue&type=template&id=082db400&"
import script from "./DealValueAddEdit.vue?vue&type=script&lang=js&"
export * from "./DealValueAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports